import { render, staticRenderFns } from "./DeniedPayment.vue?vue&type=template&id=8528a044&scoped=true"
import script from "./DeniedPayment.vue?vue&type=script&lang=js"
export * from "./DeniedPayment.vue?vue&type=script&lang=js"
import style0 from "./DeniedPayment.vue?vue&type=style&index=0&id=8528a044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8528a044",
  null
  
)

export default component.exports